module.exports = __webpack_public_path__ + "img/card-dog-4.228ab2d4.png";